import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import "./index.css";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { HashRouter } from "react-router-dom";
import { registerLicense } from "@syncfusion/ej2-base";
import { slk } from "survey-core";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance
  .initialize()
  .then(() => {
    msalInstance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log("Redirect login successful:");
        }
      })
      .catch((error) => {
        console.error("MSAL redirect handling failed", error);
      });
  })
  .catch((error) => {
    console.error("MSAL initialization failed", error);
  });

slk(process.env.REACT_APP_SURVEYJS_KEY);
registerLicense(process.env.REACT_APP_SYNCFUSION_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </MsalProvider>
  </React.StrictMode>
);
